import React from 'react';
import cx from 'classnames';

// For reference:
// https://medium.com/@willhowardgb/building-a-beautiful-text-input-component-in-react-f85564cc7e86
// https://codesandbox.io/s/yqlz84rnyv
class CustomBenchmarkFormField extends React.Component {
  constructor (props) {
    super(props)

    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    const value = event.target.value;
    this.props.onReceiveUserInput(value, this.props.id);
  }

  render() {
    const fieldStyle = cx({
      "customBenchmarkFormField": true,
      "numberField": this.props.isNumberForm,
    });

    let units = this.props.units
    if(parseFloat(this.props.value) < 0 && this.props.units == "Lexile") {
      units = "BR";
    }
    let hideUnits = false;
    if(this.props.value == '') {
      hideUnits = true;
    }
    const unitStyle = cx({
      "amiraInputUnits": true,
      "hiddenUnits": hideUnits,
    });

    return (
      <div className={fieldStyle}>
        <input
          className="amiraInput"
          placeholder={this.props.placeholder}
          type="text"
          onChange={this.onChange}
          value={this.props.value}
          />
        {this.props.units && <div className={unitStyle}> {units} </div>}
      </div>
    )
  }
}

CustomBenchmarkFormField.defaultProps = {
  placeholder: '',
  unit: false,
  id: null,
  onReceiveUserInput: null,
  isNumberForm: false,
  value: '',
}

export default CustomBenchmarkFormField;